import React from "react";
import HeroSection from "./HeroSection";
import Sec2 from "./Sec2";
import Card from "./Card";
import Gametable from "./Gametable";
import Feedback from "./Feedback";

function Home() {
  return (
    <>
      <HeroSection />
      <Sec2 />
      <Card />
      <Gametable />
      <Feedback />
    </>
  );
}

export default Home;
